export const environment = {
  production: false,
  productLogoLarge: '',
  serverUrl: 'https://sm-api-gateway-service-dev.optimusai.ai/api/v1/',
  payazaPublicKey: 'PZ78-PKTEST-1399C5E1-C315-4C9B-9B93-F91BBD79D0DC',
  payazaConnectionMode: 'Test',
};
